/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';

const infoMaterialsCollectionRN =
  'infoMaterialsModule.collections.infoMaterialsCollection';

class InfoMaterialPopUp extends Component {
  constructor(props) {
    super(props);
    if (!props.selectInfoMaterial) {
      props.dataRequestInfoMaterial();
    }
  }

  render() {
    if (this.props.requestState.requestInProcess) {
      return (
        <div className="modal-dialog modal-gray" role="document">
          <div className="modal-content">
            <MediumPreLoader />
          </div>
        </div>
      );
    } else if (!this.props.selectInfoMaterial) {
      return (
        <div
          className="modal-dialog modal-gray"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-body">
              {t('Инфо-материал {id} не найден', { id: this.props.id })}.
            </div>
          </div>
        </div>
      );
    }
    return (
      <div
        className="modal-dialog modal-gray"
        role="document"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              className="close close-black"
              data-dismiss="modal"
              href=""
              onClick={this.props.handleClose}
            />
            <h4 className="modal-title">
              {this.props.selectInfoMaterial.title}
            </h4>
          </div>
          <div className="modal-body">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: this.props.selectInfoMaterial.content
              }}
            />
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary btn-block"
              data-dismiss="modal"
              type="button"
              onClick={this.props.handleClose}
            >
              {t('Все понятно')}!
            </button>
          </div>
        </div>
      </div>
    );
  }
}

InfoMaterialPopUp.defaultProps = {
  selectInfoMaterial: null
};

InfoMaterialPopUp.propTypes = {
  // IN
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,

  // CONNECT
  selectInfoMaterial: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  }),
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  dataRequestInfoMaterial: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectInfoMaterial: selectItemById(
    state,
    infoMaterialsCollectionRN,
    props.id
  ),
  requestState: selectRequestsStateById(
    state,
    infoMaterialsCollectionRN,
    props.id
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequestInfoMaterial: () =>
    dispatch(dataRequest(infoMaterialsCollectionRN, props.id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoMaterialPopUp);



// WEBPACK FOOTER //
// ./src/components/InfoMaterials/InfoMaterialPopUp/InfoMaterialPopUp.js